<template>
  <v-dialog :value="value" @input="(aberto) => $emit('input', aberto)" width="560" persistent>
    <v-card>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(salvar)">
          <v-card-title class="text-h6">Registrar Acompanhamento</v-card-title>

          <v-card-text>
            <e-label>Tipo da ação</e-label>
            <ValidationProvider name="Tipo da ação" rules="required" v-slot="{ errors }">
              <e-autocomplete
                :error-messages="errors"
                :items="tipos"
                :item-text="(tipo) => tipo.rotulo"
                :item-value="(tipo) => tipo.valor"
                v-model="form.tipo"
                placeholder="Selecione o tipo"
                dense
                solo
              />
            </ValidationProvider>

            <template v-if="form.tipo === 'outros'">
              <e-label>Descreva a ação</e-label>
              <ValidationProvider name="Descrição da ação" rules="required" v-slot="{ errors }">
                <v-text-field
                  :error-messages="errors"
                  v-model="form.tipo_outros"
                  placeholder="O que foi feito"
                  counter="255"
                  maxlength="255"
                  dense
                  solo
                />
              </ValidationProvider>
            </template>

            <e-label>Data da ação</e-label>
            <ValidationProvider name="Data da ação" rules="required" v-slot="{ errors }">
              <v-menu v-model="menuData" :close-on-content-click="false" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :error-messages="errors"
                    :value="dataLegivel"
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar"
                    placeholder="Selecione a data"
                    readonly
                    dense
                    solo
                  />
                </template>
                <v-date-picker
                  v-model="form.data_acao"
                  :max="hoje"
                  no-title
                  @input="menuData = false"
                />
              </v-menu>
            </ValidationProvider>

            <e-label>Responsável pela ação</e-label>
            <ValidationProvider name="Responsável" rules="required" v-slot="{ errors }">
              <e-autocomplete
                :error-messages="errors"
                :items="responsaveis"
                :item-text="rotuloDoResponsavel"
                :item-value="(responsavel) => responsavel.id"
                v-model="form.responsavel_user_id"
                placeholder="Coordenador, Diretor ou Supervisor"
                dense
                solo
              />
            </ValidationProvider>

            <e-label>Observação</e-label>
            <v-textarea v-model="form.observacao" rows="3" placeholder="Opcional" dense solo />
          </v-card-text>

          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn color="secondary" type="button" small @click="fechar">Cancelar</v-btn>
            <v-btn color="primary" type="submit" :loading="salvando" small>Salvar</v-btn>
          </v-card-actions>
        </form>
      </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EModalRegistrarAcompanhamento",
  props: {
    value: { type: Boolean, default: false },
    casoId: { type: [Number, String], required: true },
    tipos: { type: Array, default: () => [] },
    responsaveis: { type: Array, default: () => [] },
  },
  data() {
    return {
      form: {},
      menuData: false,
      salvando: false,
    };
  },
  computed: {
    hoje() {
      const agora = new Date();
      return [
        agora.getFullYear(),
        `${agora.getMonth() + 1}`.padStart(2, "0"),
        `${agora.getDate()}`.padStart(2, "0"),
      ].join("-");
    },
    dataLegivel() {
      if (!this.form.data_acao) return "";
      const [ano, mes, dia] = this.form.data_acao.split("-");
      return `${dia}/${mes}/${ano}`;
    },
  },
  watch: {
    value(aberto) {
      if (aberto) {
        this.form = { tipo: null, tipo_outros: null, data_acao: this.hoje, observacao: null };
      }
    },
  },
  methods: {
    rotuloDoResponsavel(responsavel) {
      if (!responsavel.papel) return responsavel.nome;
      return `${responsavel.nome} (${responsavel.papel.toUpperCase()})`;
    },
    fechar() {
      this.$emit("input", false);
    },
    async salvar() {
      this.salvando = true;
      try {
        const resposta = await this.$services.buscaAtivaService.registrarAcompanhamento(
          this.casoId,
          this.form
        );
        this.$toast.success("Acompanhamento registrado com sucesso");
        this.$emit("registrado", resposta);
        this.fechar();
      } catch (error) {
        this.$handleError(error);
      }
      this.salvando = false;
    },
  },
};
</script>
